<template>
  <div class="group mb-[5px] relative top-0 mt-[36px] pt-[30px] block text-left w-[184px] 2xl:w-[216px] bg-no-repeat bg-[position:50%_70%] bg-white shadow-xl rounded-[6px] transition-all duration-300 overflow-hidden text-[#223265] border-[3px] border-transparent hover:border-[#FE965D]"
    :class="[{'border-[3px] !border-[#F84346] rounded-t-none hover:border-[#F84346]': sku.popular === true, '!w-[178px] 2xl:!w-[200px]': shrink, 'is-disabled opacity-60 !border-[#d9dde8] hover:!border-[#d9dde8]': isDisabled }]" :style="sku.popular === true ? 'overflow: initial;':''">

    <el-skeleton class="w-full min-h-[506px]" :loading="sku.id === ''" animated>
      <template slot="template">
        <div style="padding: 14px;">
          <el-skeleton-item variant="h3" style="width: 50%;" />
          <div style="display: flex; align-items: center; justify-items: space-between; margin-top: 16px; height: 16px;">
            <el-skeleton-item variant="text" style="margin-right: 16px;" />
            <el-skeleton-item variant="text" style="width: 30%;" />
          </div>
        </div>
      </template>
      <template>
        <!-- activity -->
        <div v-if="sku.price !== sku.salePrice" :class="['absolute top-0 left-[50%] right-[9px] translate-x-[-50%] w-[126px] h-[28px] text-center bg-[url(@/assets/index/img/activities/plan_activity.svg)] bg-no-repeat bg-center',
          { '!w-auto !h-[30px] !bg-none': sku.popular === true }]">
          <div class="h-full">
            <span class="text-[14px] font-medium text-white leading-[28px]">
              <img v-if="sku.popular === true" src="@/assets/index/img/activities/activity_20off.svg" alt="" class="h-full">
              <span v-else>{{ sku.discountRatio }}%
                {{ $t("cpts.plan_view.discount") }}</span>
            </span>
          </div>
        </div>

        <!-- popular-->
        <div v-if="sku.popular === true"
          class="absolute text-center h-[36px] bg-[#F84346] rounded-t-[6px] rounded-b-none -top-[36px] -left-[3px] transform-none"
          style="width: calc(100% + 6px)">
          <span class="text-[18px] font-medium text-white leading-[36px]">{{ $t("cpts.plan_view.popular") }}</span>
        </div>

        <!--capacity-->
        <p class="px-[10px] text-[17px] uppercase mb-[28px] leading-[26px] min-h-[52px] text-center font-bold flex items-center justify-center"><span>{{ sku.desc }}</span>
        </p>

        <div v-if="sku.firstOrderOnly" class="absolute left-1/2 top-[86px] z-10 w-max max-w-[86%] -translate-x-1/2 rounded-[12px] px-[10px] py-[3px] text-[12px] leading-[16px] text-[#F84346] bg-[#fff1f1] border border-[#ffd1d1] text-center">
          {{ $t("cpts.plan_view.first_order_only") }}
        </div>

        <!--price-->
        <div class="text-center mb-[18px] leading-none">
          <span class="text-[22px]">$</span>
          <span class="text-[36px] 2xl:text-[40px]">{{ type == TypeCustomized ? '?' : displaySalePrice }}</span>
          <span v-if="type != TypeUnlimitFlow && type != TypeCustomized && displayPrice > displaySalePrice" class="text-[16px] text-[#CCCCCC]">/
            <span  class="line-through">{{ displayPrice }}</span>
          </span>
        </div>
        <div v-if="showPromotionPrice" class="mx-auto mb-[14px] flex w-[calc(100%-24px)] items-center justify-center gap-[6px] rounded-[14px] border border-[#ffd6b8] bg-[#fff4df] px-[8px] py-[5px] text-center text-[12px] leading-[16px] text-[#8b4210]">
          <span class="font-bold">{{ promotionBadge }}</span>
          <span>{{ $t('activity.summer.save') }}</span>
          <span class="text-[15px] font-bold text-[#ff7a22]">${{ displayPromotionSaving }}</span>
        </div>
        <div v-if="type == TypeUnlimitFlow || type == TypeCustomized" class="mb-[20px] text-center text-[16px] leading-none">
            <p v-if="type != TypeCustomized" class="leading-[24px] line-through text-[#CCCCCC]"><span>$</span><span>{{ displayPrice }}</span></p>
            <p v-else class="leading-[24px] text-[#CCCCCC]"><span>&nbsp;</span></p>
        </div>

        <!--duration -->
        <div v-if="type == TypeTraffic" class="mb-[20px] text-center text-[16px] leading-none">
          <div class="w-full px-[10px] text-[14px] font-small flex justify-center items-center">
            <!-- <div class="flex items-center h-[25px] mr-[5px] bg-transparent border border-[#918678] rounded-[5px]">
              <div @click="reduceDuration" class="shrink-0 w-[25px] h-full leading-[23px] text-center cursor-pointer">-
              </div>
              <input type="number" name="number" :value="duration" readonly="readonly"
                class="w-[35px] h-full bg-transparent outline-none text-center text-[#FE965D]" ref="durationView">
              <div @click="extendDuration" class="shrink-0 w-[25px] h-full leading-[23px] text-center cursor-pointer">+
              </div>
            </div> -->
            <span class="w-max text-[16px] leading-[24px] text-[#FF9000] h-[24px] px-[10px] text-center">{{ duration }}</span>
            <div>{{ $t("cpts.plan_view.days") }}</div>
          </div>
        </div>
        <div v-if="type == TypeUnlimitFlow" class="flex items-center justify-center mb-[32px]">
          <span class="w-max bg-[#ff90001a] rounded-[90px] text-[16px] leading-[24px] text-[#FF9000] min-w-[74px] px-[10px] box-border text-center">
            {{ displayTime }}
          </span>
        </div>

        <div v-if="type == TypeCustomized" class="flex items-center justify-center mb-[32px]">
          <p class="h-[24px] text-[12px] text-[#223265] bg-transparent rounded-[9px] pt-0 text-center">{{ $t("cpts.plan_view.customized_instructions") }}</p>
        </div>

        <!--traffic prices-->
        <div v-if="type == TypeTraffic" class="flex items-center justify-center mb-[32px]">
          <span
            class="w-max bg-[#ff90001a] rounded-[90px] text-[16px] leading-[24px] text-[#FF9000] h-[24px] px-[10px] min-w-[74px] text-center">${{
              displayUnitPrice }}/GB</span>
        </div>

        <!--buy button-->
        <p class="mb-[30px] px-[16px] text-center">
          <a @click="clickBuy"
            :class="['block mx-auto rounded-[18px] w-full max-w-[124px] 2xl:max-w-[131px] h-[35px] text-center leading-[35px] text-[17px] 2xl:text-[18px] border',
              isDisabled ? 'text-[#a8afc2] bg-[#f2f4f8] border-[#d9dde8] cursor-not-allowed pointer-events-none' : 'text-[#FE965D] bg-[#fff] border-[#FE965D] cursor-pointer group-hover:bg-[#FE965D] group-hover:text-white']">
            {{ isDisabled ? $t("cpts.plan_view.actions.unavailable") : (type === TypeCustomized ? $t("cpts.plan_view.actions.contacts") : $t("cpts.plan_view.actions.buy")) }}</a>
        </p>

        <!--detail-->
        <div class="w-full rounded-t-none rounded-b-[10px] bg-transparent">
          <p
            class="w-full h-[57px] box-md text-[15px] 2xl:text-[16px] bg-[#454545] bg-clip-text text-transparent flex items-center justify-center px-[8px] text-center shadow-[0px_0px_13px_0px_rgba(216,219,224,0.28)]">
            <span>{{ displayTraffic }}</span>
          </p>
          <p
            class="w-full h-[57px] box-md text-[15px] 2xl:text-[16px] bg-[#454545] bg-clip-text text-transparent flex items-center justify-center px-[8px] text-center shadow-[0px_0px_13px_0px_rgba(216,219,224,0.28)]">
            <span>{{ $t("cpts.plan_view.unlimited_ip_amount") }}</span>
          </p>
          <p 
            class="w-full h-[57px] box-md text-[15px] 2xl:text-[16px] bg-[#454545] bg-clip-text text-transparent flex items-center justify-center px-[8px] text-center shadow-[0px_0px_13px_0px_rgba(216,219,224,0.28)]">
            <span>{{ $t("cpts.plan_view.country_available") }}</span>
          </p>
        </div>      
      </template>
    </el-skeleton>
  </div>
</template>

<script>
import { calculatePromotionDiscount, isPromotionEligibleType, promotionText } from '@/config/site-theme'

const addResidentalDay = 30
const maxAddResidentalDay = 180
const defaultResidentalDay = 30
const minReduceResidentalDay = 30
const comeUpDisscountRatio = 0.1

function multiplyNum(num1, num2) {
  let multipleNum = 1000
  let num = ((num1 * multipleNum) * (num2 * multipleNum)) / (multipleNum * multipleNum)
  return num
}

function divisionNum(num1, num2) {
  let multipleNum = 1000
  let num = ((num1 * multipleNum) / (num2 * multipleNum))
  return num
}

export default {
  name: 'SkuView',
  data() {
    return {
      changeResidentalDayType: true,
      amount: 1,
      comeUpRatio: 1,
      duration: 0,
    }
  },
  props: {
    type: {
      type: Number,
      readonly: true,
      default: 0,
    },
    spu: {
      type: Object,
      required: true,
      readonly: true,
    },
    sku: {
      type: Object,
      readonly: true,
      default: function () {
        return  {
                  skuId: -1,
                  desc: 'customized',
                  salePrice: 0, // 价格
                  price: 0,
                  discountRatio: 0,  // 折扣率%
                  duration: 0,
                }
      }
    },
    shrink: {
      type: Boolean,
      default: false,
    },
  
  },
  created() {
    if (this.sku && this.sku.duration) {
      this.duration = this.sku.duration;
    }
  },
  watch: {
    sku: {
      handler(newVal) {
        if (newVal && newVal.duration) {
          this.duration = newVal.duration;
        } else {
          this.duration = 0; 
        }
      },
      deep: true, 
      immediate: true
    }
  },
  computed: {
    TypeTraffic() {
      return 1
    },
    TypeUnlimitFlow() {
      return 0
    },
    TypeCustomized() {
      return 999
    },

    displayPrice() {
      let original_unit_money = this.sku.price
      let comeUpOriginalMoney = multiplyNum(original_unit_money, this.comeUpRatio)
      return comeUpOriginalMoney;
    },
    displaySalePrice() {
      let discount_unit_money = this.sku.salePrice
      let comeUpDiscountMoney = multiplyNum(discount_unit_money, this.comeUpRatio)
      return comeUpDiscountMoney;
    },
    displayUnitPrice() {
      let discount_unit_money = this.sku.salePrice
      let all_flow = this.sku.flow / 1024 + this.sku.give / 1024

      let comeUpDiscountMoney = multiplyNum(discount_unit_money, this.comeUpRatio)
      let unit = Math.round(divisionNum(comeUpDiscountMoney, all_flow) * 100) / 100;
      return unit
    },
    displayTime() {
      if (this.duration == 1) {
        return 24 + this.$t("cpts.plan_view.hours")
      } else {
        return this.duration + this.$t("cpts.plan_view.days")
      }
    },
    displayTraffic() {
      if (this.type == this.TypeUnlimitFlow) {
        return this.$t("cpts.plan_view.unlimited")
      }

      let totalFlow = Number(this.sku.flow || 0) + Number(this.sku.give || 0)
      let gb = totalFlow / 1024
      let text = gb >= 10 ? Math.round(gb).toString() : (Math.round(gb * 10) / 10).toString()

      return text + 'GB'
    },
    isDisabled() {
      return this.sku && this.sku.canBuy === false;
    },
    promotionEligible() {
      return isPromotionEligibleType(this.type);
    },
    showPromotionPrice() {
      return this.promotionEligible && !this.isDisabled && this.type !== this.TypeCustomized;
    },
    promotionBadge() {
      return promotionText(this, 'badge');
    },
    displayPromotionSaving() {
      const salePrice = Number(this.displaySalePrice);
      if (!Number.isFinite(salePrice)) {
        return this.displaySalePrice;
      }

      const saving = Math.round(calculatePromotionDiscount(salePrice) * 100) / 100;
      return Number.isInteger(saving) ? String(saving) : saving.toFixed(2);
    }
  },
  methods: {
    extendDuration() {
      if (this.changeResidentalDayType) {
        this.changeResidentalDayType = false
        let value = this.duration
        if (value >= maxAddResidentalDay) {
          this.changeResidentalDayType = true
          return false
        } else {
          value += addResidentalDay
          this.duration = value
          this.amount = divisionNum(value, defaultResidentalDay)
          this.comeUpRatio = 1 + multiplyNum(comeUpDisscountRatio, (this.amount - 1))
          this.changeResidentalDayType = true
        }
      } else {
        return false
      }
    },

    reduceDuration() {
      if (this.changeResidentalDayType) {
        this.changeResidentalDayType = false
        let value = this.duration
        if (value <= minReduceResidentalDay) {
          this.changeResidentalDayType = true
          return false
        } else {
          value -= addResidentalDay
          this.duration = value

          this.amount = divisionNum(value, defaultResidentalDay)
          this.comeUpRatio = 1 + multiplyNum(comeUpDisscountRatio, (this.amount - 1))
          this.changeResidentalDayType = true
        }
      } else {
        return false
      }
    },

    clickBuy() {
      if (this.isDisabled) {
        return
      }
      this.$emit('click-buy-plan', this.sku, this.duration)
    },
  },
}
</script>
